import { Apply, FilterJob, Job, OrderApply, OrderInfo, OrderRefusal, ResponseDetail, ShintyokuResponseDetail, UpdateResponse } from '@/types';
import {
  OrderLocationDetail,
  TrnShintyokuPageCursor,
  TrnShintyokuSelectRequest
} from '@/types/request';
import {
  getShintyoku,
  getLocation,
  setFavorite as setFavoriteEndPoint,
  setRefusalShintyoku,
  setApplyShintyoku,
  setApplyShintyokuFromSearch,
  writeLogtrnOperationLog as writeLogtrnOperationLogEndPoint,
  getCountApplyList as getShintyokuCountApplyList,
  setReApplyShintyoku,
  setApplyPublicShintyoku,
  getOrdersInfo,
  getOrdersDetail,
  countCloseApplyProgress
} from '../shintyokuEndpoint';
import { getMstNameByIdService } from './mstMyPageService';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import store from '@/store';
import { FromPage, OrdersInfo } from '@/store/modules/orders';
const PENDING_FLG_ON = 1;
const PENDING_FLG_OFF = 0;

const LASTINTERVIEW_FLG_ON = 1;

const SHINTYOKU_STATUS_NG_CONTACT = 7;
const SHINTYOKU_STATUS_SAIYOU_CLOSE = 24;
const SHINTYOKU_STATUS_SENKOUBI_SETTEICHU = 2;
const SHINTYOKU_STATUS_SENKOUBI_KAKUTEI = 3;
const SHINTYOKU_STATUS_INTERVIEW_DATE_CONFIRMED = 27;

// 担当者おすすめから応募
export const APPLY_TYPE_ORDER_CA_INTRODUCE = 1;
// 求人検索から応募
export const APPLY_TYPE_ORDER_JOB_SEARCH_PUBLIC = 2;
// マイナビ転職掲載中求人から応募
export const APPLY_TYPE_ORDER_MARCH = 3;
const storeBase = MYPAGE_CONSTANTS.STORE_MST;

export type FavoriteDetailResponse = {
  ignoreOrder: number[];
  orderId: number[];
  responseId: string;
  responseMessage: string;
  unApprovedOrder: number[];
};

export type BaseResponseData = {
  responseId: string;
  responseMessage: string;
};

const getShintyokuList = async (params: TrnShintyokuSelectRequest, isFromPendingList = false, fromPage: FromPage) => {
  const shintyokuList: Job[] = [];

  const shintyokuInfo = await getShintyoku(params);

  const filterAvailable : FilterJob = {};
  const pageCursor : TrnShintyokuPageCursor = {};

  if (shintyokuInfo.data.detail != null) {
    const orderIds = shintyokuInfo.data.detail.map((v: { orderId: string }) => v.orderId) || [];
    // Get Orders Location
    const locationOrders : OrderLocationDetail[] = await fetchOrderLocationDetails(orderIds, '1') || [];
    // Get Orders by OrderIds
    const orders : OrderInfo[] = await getOrdersDetail({orderIds: orderIds}) || [];

    // Set Orders Info State to using for the GTM Trigger
    const ordersInfoState: OrdersInfo = {
      orders: [...orders].map((order: OrderInfo) => ({
        orderId: order.orderId,
        isAiRecommended: order?.trnShintyokuWithCareer?.[0]?.isAiRecommended ?? false,
        isNewRecommended: order?.trnShintyokuWithCareer?.[0]?.isNewRecommended ?? false,
      })),
      fromPage: fromPage,
    };
    store.commit('orders/setOrdersInfo', ordersInfoState);

    for (const info of shintyokuInfo.data.detail) {
      // 担当おすすめ
      const isRecommendedByStaff = info.orderCaintroduceFlg;
      // 弊社企業担当おすすめ
      const isRecommendedByClient = info.orderRaintroduceFlg;
      // 新着レコメンド
      const isNewRecommended = info.orderAutosendFlg;
      // AIレコメンド
      const isAiRecommended = info.orderAiRecommendFlg == 1;
      // 応募歓迎
      const isWelcome = info.orderWelcomeapplyFlg;
      // 公開求人から検索
      const isJobSearchPublic = info.orderJobSearchPublicFlg;
      // 紹介日
      let introduceDate = info.introduceDate;
      // "YYYY/MM/DD HH:MM:SS" 形式から "YYYY/MM/DD" 部分のみを抽出
      if (introduceDate && introduceDate.includes(' ')) {
        introduceDate = introduceDate.split(' ')[0];
      }
      // 求人情報取得
      // const orderInfo = await getOrderInfo(info.orderId);
      const orderInfo = orders.find(v => v.orderId === info.orderId);
      if (orderInfo) {
        // 企業名
        const companyName = orderInfo.clientName;
        // 求人タイトル
        const positionname = orderInfo.positionname;
        // 年収        
        let annualIncome = '';
        const minannualincm = orderInfo.minannualincm;
        const maxannualincm = orderInfo.maxannualincm;
        if (minannualincm && maxannualincm) {
          annualIncome = minannualincm + '万円～' + maxannualincm + '万円';
        } else if (minannualincm && !maxannualincm) {
          annualIncome = minannualincm + '万円～';
        } else if (!minannualincm && maxannualincm) {
          annualIncome = '～' + maxannualincm + '万円';
        }
        // 勤務地(都道府県 市区町村)
        const locationInfo = locationOrders.find(v => v.orderId === info.orderId);
        const workLocation = await formatOrderLocationDetail(locationInfo);

        // 仕事内容
        let wkcontents = orderInfo.wkcontents || '';
        // 最大100文字。101字目は「…」
        if (wkcontents && wkcontents.length > 100) {
          wkcontents = wkcontents.substring(0, 100) + '…';
        }
        // 担当者コメント
        let recommendComment = info.recommendComment;
        // 最大100文字。101字目は「…」
        if (recommendComment && recommendComment.length > 100) {
          recommendComment = recommendComment.substring(0, 100) + '…';
        }
        // ピックアップ
        const pickupLink = orderInfo.clientUrlPickupThisMonth;
        // 気になる
        let pendingFlg = false;
        if (isFromPendingList) {
          pendingFlg = true;
        } else {
          pendingFlg = info.pendingFlg == PENDING_FLG_ON;
        }
        const isLiked = info.isLiked;
        const isMarchFlg = info.isMarchFlg;
        // 募集終了
        const isOrderClose = orderInfo.isOrderClose;
        // client id
        const clientId = orderInfo.clientId;
        let isApplied = false;
        let isRefusal = false;
        let statusId = 0;
        if(orderInfo.hasProgress && orderInfo.trnShintyokuWithCareer.length > 0){
          isApplied = orderInfo.trnShintyokuWithCareer[0].isApplied;
          isRefusal = orderInfo.trnShintyokuWithCareer[0].isRefusal;
          statusId = orderInfo.trnShintyokuWithCareer[0].statusId;
        }

        shintyokuList.push({
          progressId: info.progressId,
          orderId: info.orderId,
          clientId: String(clientId),
          isRecommendedByStaff: isRecommendedByStaff,
          isRecommendedByClient: isRecommendedByClient,
          isNewRecommended: isNewRecommended,
          isAiRecommended: isAiRecommended,
          companyName: companyName,
          jobTitle: positionname,
          isWelcome: isWelcome,
          pickupLink: pickupLink,
          introductionDate: introduceDate,
          annualIncome: annualIncome,
          workLocation: workLocation,
          jobDescription: wkcontents,
          staffComment: recommendComment,
          isFavorite: pendingFlg,
          recruitClosed: isOrderClose,
          isJobSearchPublic: isJobSearchPublic,
          isApply: isApplied,
          isRefusal: isRefusal,
          statusId: statusId,
          isLiked: isLiked,
          isMarchFlg: isMarchFlg
        });
      }
    }
  }
  if(shintyokuInfo.data.filter){
    filterAvailable.minDate = new Date(shintyokuInfo.data.filter.minDateTime);
    filterAvailable.maxDate = new Date(shintyokuInfo.data.filter.maxDateTime);
  }
  if(shintyokuInfo.data.pageCursor){
    pageCursor.recommendDisporderId = shintyokuInfo.data.pageCursor.recommendDisporderId;
    pageCursor.progressDate = shintyokuInfo.data.pageCursor.progressDate;
    pageCursor.progressId = shintyokuInfo.data.pageCursor.progressId;

    pageCursor.orderId = shintyokuInfo.data.pageCursor.orderId;
    pageCursor.updateDate = shintyokuInfo.data.pageCursor.updateDate;
  }
  return { shintyokuList, totalCount: shintyokuInfo.data.totalCount ?? 0, filterAvailable, pageCursor, hasMore : shintyokuInfo.data.hasMore };
};

const getSttNameMyPage = (shintyoku: any) => {
  let statusId, progressDate, lastInterviewFlg, sttNameMP;
  if (shintyoku.statusId == SHINTYOKU_STATUS_NG_CONTACT || shintyoku.statusId == SHINTYOKU_STATUS_SAIYOU_CLOSE) {
    statusId = shintyoku.preShintyokuStatusId;
    progressDate = shintyoku.preProgressDate;
    lastInterviewFlg = shintyoku.preLastInterviewFlg;
    sttNameMP = shintyoku.preShintyokuStatusNameMp;
  } else {
    statusId = shintyoku.statusId;
    progressDate = shintyoku.progressDateSub;
    lastInterviewFlg = shintyoku.lastInterviewFlg;
    sttNameMP = shintyoku.shintyokuStatusNameMp;
  }
  const now = new Date();
  const progressDateFormat = new Date(progressDate);

  if (statusId == SHINTYOKU_STATUS_SENKOUBI_SETTEICHU) {
    return shintyoku.nextProceedId + '次' + sttNameMP;
  }
  if (statusId == SHINTYOKU_STATUS_SENKOUBI_KAKUTEI) {
    if (now < progressDateFormat) {
      return (lastInterviewFlg == LASTINTERVIEW_FLG_ON) ? '最終選考日確定' : shintyoku.nextProceedId + '次' + sttNameMP;
    } else {
      return (lastInterviewFlg == LASTINTERVIEW_FLG_ON) ? '最終選考中' : shintyoku.nextProceedId + '次選考中';
    }
  }
  if (statusId == SHINTYOKU_STATUS_INTERVIEW_DATE_CONFIRMED && now > progressDateFormat) {
    return '内定/ご検討中';
  }
  return sttNameMP;
};


const fetchOrderLocationDetails = async(orderIds: string[], locationNo: string) => {
  let results : OrderLocationDetail[] = [];
  const locationOrders = await getLocation({
    orderIds: orderIds,
    locationNo: locationNo
  });
  if (locationOrders && locationOrders.data && locationOrders.data.detail) {
    results = locationOrders.data.detail as OrderLocationDetail[];
  }
  return results;
};

const formatOrderLocationDetail = async (orderLocation: OrderLocationDetail | undefined) => {
  if (!orderLocation) return '';
  const prefName = await getMstNameByIdService(orderLocation.prefId, storeBase.MST_PREF, store);
  const cityName = await getMstNameByIdService(orderLocation.cityId, storeBase.MST_CITY, store);
  return (prefName ?? '') + (cityName ?? '') +  (orderLocation.addr ?? '');
};


const getShintyokuAppliedList = async (params: TrnShintyokuSelectRequest, fromPage: FromPage) => {
  const appliedList: Apply[] = [];
  const shintyokuInfo = await getShintyoku(params);
  const pageCursor : TrnShintyokuPageCursor = {};
  if (shintyokuInfo.data.detail != null) {
    const orderIds: string[] = shintyokuInfo.data.detail.map((v: { orderId: string }) => v.orderId) || [];
    const locationOrders = await fetchOrderLocationDetails(orderIds, '1');
    const ordersInfo : OrderInfo[] = await getOrdersInfo({orderIds: orderIds.map(Number).filter(v => !isNaN(v))});

    // Set Orders Info State to using for the GTM Trigger
    const ordersInfoState: OrdersInfo = {
      orders: [...ordersInfo].map((order: OrderInfo) => ({
        orderId: order.orderId,
        isAiRecommended: order?.trnShintyokuWithCareer?.[0]?.isAiRecommended ?? false,
        isNewRecommended: order?.trnShintyokuWithCareer?.[0]?.isNewRecommended ?? false,
      })),
      fromPage: fromPage,
    };
    store.commit('orders/setOrdersInfo', ordersInfoState);

    for (const info of shintyokuInfo.data.detail) {
      const selection = getSttNameMyPage(info);
      const applicationPreference = info.aspiration;
      const applicationDate = info.applicationDate;
      let appliedFlg = 0;
      if (info.orderMarchFlag) {
        appliedFlg = APPLY_TYPE_ORDER_MARCH;
      } else if (info.orderJobSearchPublicFlg) {
        appliedFlg = APPLY_TYPE_ORDER_JOB_SEARCH_PUBLIC;
      } else if (info.orderCaintroduceFlg) {
        appliedFlg = APPLY_TYPE_ORDER_CA_INTRODUCE;
      }
      // 求人情報取得
      const orderInfo = ordersInfo.find(v => v.orderId === info.orderId);
      if (orderInfo) {
        // 企業名
        const companyName = orderInfo.clientName;
        // 求人タイトル
        const positionname = orderInfo.positionname;
        // 年収
        let annualIncome = '';
        const minannualincm = orderInfo.minannualincm;
        const maxannualincm = orderInfo.maxannualincm;
        if (minannualincm && maxannualincm) {
          annualIncome = minannualincm + '万円～' + maxannualincm + '万円';
        } else if (minannualincm && !maxannualincm) {
          annualIncome = minannualincm + '万円～';
        } else if (!minannualincm && maxannualincm) {
          annualIncome = '～' + maxannualincm + '万円';
        }
        const isMarchFlg = info.isMarchFlg;
        // 勤務地(都道府県 市区町村)
        const locationInfo = locationOrders.find(v => v.orderId === info.orderId);
        const workLocation = await formatOrderLocationDetail(locationInfo);

        // client id
        const clientId = orderInfo.clientId;
        appliedList.push({
          orderId: info.orderId,
          clientId: String(clientId),
          companyName: companyName,
          jobTitle: positionname,
          annualIncome: annualIncome,
          workLocation: workLocation,
          applicationPreference: applicationPreference,
          applicationDate: applicationDate,
          appliedFlg: appliedFlg,
          selection: selection,
          isMarchFlg: isMarchFlg
        });
      }
    }
    
    if(shintyokuInfo.data.pageCursor){
      pageCursor.recommendDisporderId = shintyokuInfo.data.pageCursor.recommendDisporderId;
      pageCursor.progressDate = shintyokuInfo.data.pageCursor.progressDate;
      pageCursor.progressId = shintyokuInfo.data.pageCursor.progressId;

      pageCursor.orderId = shintyokuInfo.data.pageCursor.orderId;
      pageCursor.updateDate = shintyokuInfo.data.pageCursor.updateDate;
      pageCursor.maxSubInsertDate = shintyokuInfo.data.pageCursor.maxSubInsertDate;
    }
  }
  return { shintyokuList: appliedList, totalCount: shintyokuInfo.data.totalCount ?? 0, pageCursor, hasMore : shintyokuInfo.data.hasMore, totalCountCloseAply: shintyokuInfo.data.totalCountCloseAply ?? 0 };
};

export const setFavoriteService = async (params: { orderIds: number[], isFavorite: boolean }) => {
  const pendingFlg = params.isFavorite ? PENDING_FLG_ON : PENDING_FLG_OFF;
  const requestParams = {
    orderIds: params.orderIds,
    pendingFlg: pendingFlg,
  };
  const res = await setFavoriteEndPoint(requestParams);
  return res.data.detail as FavoriteDetailResponse;
};


export const writeLogtrnOperationLogService = async (params: { orderId: number, clientId: number, operationId: number, videoUrl: string }) => {
  const requestParams = {
    orderId: params.orderId,
    clientId: params.clientId,
    operationId: params.operationId,
    videoUrl: params.videoUrl
  };
  const res = await writeLogtrnOperationLogEndPoint(requestParams);
  return res.data.detail as BaseResponseData;
};

export const getJobSearchListService = async (params: TrnShintyokuSelectRequest, isLoadOrder = true) => {
  params.src2 = 2;
  if (isLoadOrder) {
    return await getShintyokuList(params, false, FromPage.SEARCH);
  } else {
    const shintyokuInfo = await getShintyoku(params);
    return {
      shintyokuList: [] as Job[],
      totalCount: shintyokuInfo.data.totalCount ?? 0,
      filterAvailable: {} as FilterJob,
      pageCursor: {} as TrnShintyokuPageCursor,
      hasMore : shintyokuInfo.data.hasMore
    };
  }
};

export const getRefusalListService = async (params: TrnShintyokuSelectRequest) => {
  params.src2 = 4;
  return await getShintyokuList(params, false, FromPage.REFUSE);
};

/**
 * Submit Update For Refusal
 * @param params
 * @returns
 */
export const submitUpdateRefusalShintyokuService = async (orders: OrderRefusal[]) => {
  return await setRefusalShintyoku({ orders: orders });
};

/**
 * Submit Update For Apply
 * @param params
 * @returns
 */
export const submitUpdateApplyShintyokuService = async (
  ordersApplies: OrderApply[],
  isBulkUpdate: boolean,
  canApplyPublicJob: boolean,
  isPublicJobTab: boolean,
  isReApply: boolean
) => {
  let resultApply: UpdateResponse = {} as UpdateResponse;

  if (isPublicJobTab && !canApplyPublicJob && !isBulkUpdate) {
    resultApply.orderPublicApplyException = 'Order Public Exception';
    return resultApply;
  }

  //応募する(※公開求人の場
  if (canApplyPublicJob && !isBulkUpdate) {
    if (ordersApplies.length > 0) {
      const applyOrderPublicResponse = await setApplyShintyokuFromSearch(ordersApplies[0]) as any;
      if (applyOrderPublicResponse != null && applyOrderPublicResponse.detail != null && applyOrderPublicResponse.detail.success !== 0) {
        resultApply.numberSuccess = 1;
      } else {
        resultApply.orderPublicApplySearchException = 'Exception';
      }
    } else {
      resultApply.orderPublicApplySearchException = 'Exception';
    }
    return resultApply;
  }

  // ReApply
  if (isReApply) {
    const reApplyOrderResp = await setReApplyShintyoku(ordersApplies[0]) as any;
    const faultDetail = reApplyOrderResp?.responseFaultDetail;
    if (reApplyOrderResp && !reApplyOrderResp.detail && (reApplyOrderResp.responseFault || faultDetail)) {
      if (faultDetail?.ignoredOrder) {
        resultApply.ignoreOrders = [faultDetail.ignoredOrder];
      } else if (faultDetail?.unapprovedOrder) {
        resultApply.unApprovedOrders = [faultDetail.unapprovedOrder];
      } else if (faultDetail?.reApplyDeniedOrder) {
        resultApply.reApplyDeniedOrder = [faultDetail.reApplyDeniedOrder];
      } else {
        resultApply.shintyokuUpdateException = 'Shintyoku Update Failure';
      }
    }
    return resultApply;
  }

  // Apply
  resultApply = await setApplyShintyoku(ordersApplies);
  if (resultApply.detail && !resultApply.shintyokuUpdateException) {
    return resultApply;
  }
  if (!resultApply || !resultApply.detail || resultApply.shintyokuUpdateException) {
    resultApply.shintyokuUpdateException = 'Shintyoku Update Failure';
    return resultApply;
  }
  resultApply.numberSuccess = resultApply.detail?.orderIds?.length ?? 0;
  return resultApply;
};


export const submitUpdateApplyMultipleShintyokuService = async (
  publicOrders: OrderApply[],
  privateOrders: OrderApply[]
) => {
  let resultApply: UpdateResponse = {} as UpdateResponse;  
  let publicResponse: any = null;
// Public
let sucessOrderIds = [] as number[];
let failureOrderIds = [] as number[];
let unProgressOrderIds = [] as number[];
let inValidOrderIds = [] as number[];
if (publicOrders.length > 0) {
  publicResponse = await setApplyPublicShintyoku(publicOrders);

  if (publicResponse && publicResponse.responseFault && publicResponse.detail) {
    if(publicResponse.detail.failOrderIds)
      failureOrderIds = publicResponse.detail.failOrderIds;
    if(publicResponse.detail.unProgressOrderIds)
      unProgressOrderIds = publicResponse.detail.unProgressOrderIds;
    if(publicResponse.detail.inValidOrderIds)
      inValidOrderIds = publicResponse.detail.inValidOrderIds;
    if(publicResponse.detail.orderIds)
      sucessOrderIds = publicResponse.detail.orderIds;
  }
}
// Private
if (privateOrders.length > 0) {
  resultApply = await setApplyShintyoku(privateOrders);
  if(!resultApply)
  {
    resultApply = {} as UpdateResponse;
  }
  else
  {
    if(resultApply.detail && resultApply.detail.orderIds)
       sucessOrderIds.push(...resultApply.detail.orderIds);
  }  
}

// Set response for resultApply
resultApply.successOrders = sucessOrderIds;
if (inValidOrderIds.length > 0) {
  resultApply.publicInValidOrders = inValidOrderIds;
  resultApply.orderPublicApplyException = 'Shintyoku Update Failure';
}
if (unProgressOrderIds.length > 0) {
  resultApply.publicUnProgressOrders = unProgressOrderIds;
  resultApply.orderPublicApplySearchException = 'Shintyoku Update Failure';
}
return resultApply;
};

export const getShintyokuNoSrc2Service = async (params: TrnShintyokuSelectRequest) => {
  const shintyokuList: Job[] = [];
  if (!params.page) {
    params.page = 1;
  }

  const shintyokuInfo = await getShintyoku(params);
  return { shintyokuList, totalCount: shintyokuInfo.data.totalCount ?? 0 };
};
export const getApplyListService = async (params: TrnShintyokuSelectRequest) => {
  params.src2 = 10;
  params.applySelList = 1;
  return await getShintyokuAppliedList(params, FromPage.APPLIED);
};

export const countCloseApplyProgressService = async () => {
  const response = await countCloseApplyProgress();
  if(response.data.detail)
  {
    return response.data.detail;
  }
  return 0;
};

export const getApplyClosedListService = async (params: TrnShintyokuSelectRequest) => {
  params.src2 = 10;
  params.applySelList = 0;
  return await getShintyokuAppliedList(params, FromPage.CLOSED);
};

export const getCountApplyListService = async () => {
  const response = await getShintyokuCountApplyList();
  return response.data.detail;
};

export const getPendingListService = async (params: TrnShintyokuSelectRequest) => {
  params.src2 = 6;
  params.pendingFlg = PENDING_FLG_ON;
  return await getShintyokuList(params, true, FromPage.WATCHLIST);
};

export const getRecommendedListService = async (params: TrnShintyokuSelectRequest) => {
  params.src2 = 2;
  return await getShintyokuList(params, false, FromPage.HOME);
};